import { io } from 'socket.io-client';

export const NECTOTS_API_URL = 'https://api.necttos.com' ;

const URL =  'https://api.necttos.com';

export const socket = io(URL);
